// SiteEmails -- the latest Outlook emails about one site, shown in the
// site's detail panel (site #, site email or site name in the email).

import { useEffect, useState } from 'react';
import axios from 'axios';
import { Message } from './EmailsTab.jsx';
import { categorize } from '../lib/emailSorting.js';

const SHOW = 6;

export default function SiteEmails({ site, onlySupport = false }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState(null);
  const [all, setAll] = useState(false);
  const [support, setSupport] = useState(onlySupport);

  useEffect(() => {
    axios.get(`/api/customer-emails/site/${site.id}`)
      .then((r) => setRows(r.data.rows || []))
      .catch((e) => setErr(e.response?.data?.error || e.message));
  }, [site.id]);

  if (err) return null;
  const list = (rows || []).filter((m) => !support || categorize(m.subject) === 'Support');
  const shown = all ? list : list.slice(0, SHOW);
  const href = `${window.location.pathname}?tab=emails&email_site=${site.id}${support ? '&email_cat=Support' : ''}`;

  return (
    <div className="site-emails">
      <div className="site-emails-head">
        <h4 className="preview-heading" style={{ margin: 0 }}>Site emails</h4>
        {rows && <span className="calls-dim">{list.length}</span>}
        <label className="et-remember">
          <input type="checkbox" checked={support} onChange={(e) => setSupport(e.target.checked)} /> Support only
        </label>
        <a href={href} className="site-emails-all">Open in Emails tab</a>
      </div>
      {!rows && <p className="calls-dim">Loading…</p>}
      {rows && list.length === 0 && (
        <p className="calls-dim">
          No emails about this site yet.{!site.site_email && ' Add a Site Email so emails from the store are filed here.'}
        </p>
      )}
      {shown.map((m) => (
        <div key={m.id} className="site-email-item">
          <div className="site-email-subj">
            <span className={`em-cat em-cat-${categorize(m.subject).toLowerCase()}`}>{categorize(m.subject)}</span>
            <strong>{m.subject || '(no subject)'}</strong>
          </div>
          <Message m={m} />
        </div>
      ))}
      {!all && list.length > SHOW && (
        <button type="button" className="em-clear" onClick={() => setAll(true)}>Show all {list.length}</button>
      )}
    </div>
  );
}
